/// #if PLATFORM === 'xd'
<template>
  <div
    v-if="show"
    :class="['message', type]"
    @click="clearMessage"
  >
    <span>{{ message }}</span>
    <span
      class="close"
    >✕</span>
  </div>
</template>
/// #else
<template>
  <b-alert
    :variant="type"
    :class="[$style.container, show ? $style.show : null]"
    show
  >
    {{ message }}
  </b-alert>
</template>
/// #endif

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      timer: null
    }
  },

  computed: {
    ...mapState({
      show: state => state.message.show,
      message: state => state.message.message,
      type: state => state.message.type,
      duration: state => state.message.duration
    })
  },

  watch: {
    show (value) {
      if (value) {
        this.resetTimer()
      }
    },
    message () {
      this.resetTimer()
    }
  },

  methods: {
    ...mapMutations({
      clearMessage: 'message/clearMessage'
    }),
    async resetTimer () {
      // Clear Timer if Exists
      if (this.timer) {
        window.clearInterval(this.timer)
      }
      this.timer = window.setTimeout(() => {
        this.clearMessage()
        this.timer = null
      }, this.duration)
    }
  }
}
</script>

/// #if PLATFORM !== 'xd'
<style lang="scss" module>
.container {
  position: fixed;
  bottom: 0;
  margin: map-get($spacers, 3);
  left: 0;
  right: 0;
  transform: translateY(100px);
  transition: transform 0.2s ease-in-out;
  z-index: $zindex-popover;

  &.show {
    transform: translateY(0);
  }
}
</style>
/// #endif
